// Edit this file to include new api route variables

const API_ROUTE = process.env.VUE_APP_API_ROUTE
const PSH_PROVIDER = API_ROUTE + '/pch_provider/'
// GModule
const GET_MENU_USER = API_ROUTE + '/get_menu_module_user'
const GET_LOGIN_MODULE_DATA = API_ROUTE + '/get_login_module'
// Auth token
const GET_LOGIN_TOKEN = API_ROUTE + '/auth/get_login_token'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'
// WhInventory
const WH_INVENTORY = API_ROUTE + '/wh_inventory'
const PCH_PROVIDER = API_ROUTE + '/pch_provider'
export default {
    PSH_PROVIDER,
    GET_LOGIN_MODULE_DATA,
    GET_LOGIN_TOKEN,
    GET_MENU_USER,
    LOGOUT_REQUEST,
    WH_INVENTORY,
    PCH_PROVIDER,
}
